module.exports = __webpack_public_path__ + "static/image-nim-f1fcc6ac7f1735a859ca1e7c1749714f.jpg";